// src/components/upload/BeforeUpload.js
import { useCallback } from "react";
import { useToast } from "../../toast";

export function BeforeUpload() {
  const toast = useToast();

  return useCallback(
    (file) => {
      const okTypes = ["image/jpeg", "image/jpg", "image/png"];
      const isAllowed = okTypes.includes((file.type || "").toLowerCase());
      if (!isAllowed) {
        toast("Зөвхөн PNG, JPG, JPEG зураг оруулна уу", "error");
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 <= 10;
      if (!isLt10M) {
        toast("Зураг 10MB-аас ихгүй байх ёстой", "error");
        return false;
      }
      return true;
    },
    [toast]
  );
}
